/**
 * alp-atc.js — shared Alpine store for Add-to-Cart visibility state.
 *
 * The ATC button (add-to-cart-alp) reports its viewport position here via the
 * Alpine `intersect` plugin (x-intersect / x-intersect:leave + an x-init seed).
 * Sticky bars (sticky-header / sticky-footer) read $store.atc.states[id] and
 * show/hide reactively. Replaces the old window.__atcState + 'atc-visibility'
 * CustomEvent mechanism.
 *
 * state per observer id: 'in-view' | 'above' | 'below'
 *
 * Loaded before Alpine (like alp-wishlist.js / alp-lightbox.js) so its
 * alpine:init listener registers the store before Alpine.start() fires.
 */
(function () {
  'use strict';
  if (window.__alpAtcLoaded) return;
  window.__alpAtcLoaded = true;

  document.addEventListener('alpine:init', function () {
    Alpine.store('atc', {
      states: {},
      set: function (id, state) {
        if (id) this.states[id] = state;
      },
    });

    // Migration bridge: the legacy add-to-cart.liquid block reports visibility
    // via window.__atcState + an 'atc-visibility' CustomEvent (native
    // IntersectionObserver), while add-to-cart-alp writes the store directly via
    // the Alpine intersect plugin. Mirror the legacy path into the store so the
    // sticky bars work with EITHER ATC block. Seed any state set before init,
    // then keep syncing.
    var store = Alpine.store('atc');
    if (window.__atcState) {
      Object.keys(window.__atcState).forEach(function (id) {
        store.set(id, window.__atcState[id]);
      });
    }
    window.addEventListener('atc-visibility', function (e) {
      if (e && e.detail) store.set(e.detail.id, e.detail.state);
    });
  });
})();
